import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row, Table, Spinner, Button } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';
import Flatpickr from "react-flatpickr";

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import SortHeaderComponent from "../components/SortHeaderComponent";
import PaginationComponent from "../components/PaginationComponent";
import MySearchOption from "../components/MySearchOption";
import MyDateRenderer from "../components/MyDateRenderer";
import TicketLabel from "../components/TicketLabel";
import ComplianceLabel from "../components/ComplianceLabel";
import CustomerBadge from "../components/CustomerBadge";

import { useDispatch, useSelector } from "react-redux";
import * as ticketActions from "../actions/TicketActions";

const TicketSearchScreenSOFC  = () => {
    const dispatch = useDispatch();
        
    const loading = useSelector((state) => state.ticket.loading);
    const list = useSelector((state) => state.ticket.listSOFC);
    const filter = useSelector((state) => state.ticket.filterSOFC);
    const user = useSelector((state) => state.login.user);

    const doSearch = () => {
        var copy_filter = createDeepClone(filter);
        
        if(copy_filter.pageIndex == 1) {
            dispatch(ticketActions.loadTicketSearch(filter, "SOFC"));
        }
        else {
            copy_filter.pageIndex = 1;
            dispatch(ticketActions.setTicketFilter(copy_filter, "SOFC"));
        }
    }

    React.useEffect(() => {
		dispatch(ticketActions.loadTicketSearch(filter, "SOFC"));
    }, [filter.pageIndex, filter.sortBy, filter.sortOrder]);

    const onFilterChange = (name, value) => {
        var copy_filter = createDeepClone(filter);
        copy_filter[name] = value;
        dispatch(ticketActions.setTicketFilter(copy_filter, "SOFC"));
    }

    const onSortChange = (sortBy, sortOrder) => {
        var copy_filter = createDeepClone(filter);
        copy_filter["sortBy"] = sortBy;
        copy_filter["sortOrder"] = sortOrder;
        dispatch(ticketActions.setTicketFilter(copy_filter, "SOFC"));
    }

    const onPageChange = (page) => {
        var copy_filter = createDeepClone(filter);
        copy_filter.pageIndex = page;
        dispatch(ticketActions.setTicketFilter(copy_filter, "SOFC"));
    }

    const showMyTicketsOnly = () => {
        if(user && user.showMyTicketsOnly) {
            return true;
        }

        return false;
    }
    
    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Food Ticket Search" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-3">
                                        <Col xxl={user && user.canAddRequest ? (showMyTicketsOnly() ? 6 : 8) : (showMyTicketsOnly() ? 8 : 10)} md={12}>
                                            <MySearchOption
                                                placeholder={"Search for food tickets..."}
                                                value={filter.search}
                                                searchList={list.searchList || []}
                                                fieldName="search"
                                                onChange={onFilterChange}
                                            />
                                        </Col>
                                        <Col xxl={2} md={12} className={showMyTicketsOnly() ? "" : "d-none"}>
                                            <div className="form-check pt-2 ms-2 me-2">
                                                <input type="checkbox" className="form-check-input"
                                                    checked={filter.mineOnly}
                                                    onChange={e => onFilterChange("mineOnly", e.target.checked)}
                                                /> My Tickets Only
                                            </div>
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <button type="button" className="btn btn-primary btn-label w-100" 
                                                disabled={loading}
                                                onClick= {() => doSearch()}
                                            >
                                                <i className="ri-search-eye-line label-icon align-middle"></i> Search
                                            </button>
                                        </Col>
                                        {user && user.canAddRequest &&
                                        <Col xxl={2} md={12}>
                                            <Link to={`/request-add/10`} className="btn btn-primary btn-label w-100">
                                                <i className="ri-add-line label-icon align-middle"></i> Add Ticket
                                            </Link>
                                        </Col>
                                        }
                                    </Row>
                                    <Row className="gy-3 mt-1">
                                        <Col xxl={2} md={12}>
                                            <select className="form-select"
                                                value={filter.dateType}
                                                onChange={e => onFilterChange("dateType", e.target.value)}
                                            >
                                                <option value={""}>...</option>
                                                <option value={"Added"}>Date Added</option>
                                                <option value={"LastAction"}>Last Action Date</option>
                                            </select>
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <Flatpickr className="form-control"
                                                value={filter.dateValue}
                                                onChange={(selectedDates, dateStr) => onFilterChange("dateValue", selectedDates)}
                                                options={{
                                                    enableTime: false,
                                                    mode: "range",
                                                    dateFormat: "m/d/Y"
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardLoader loading={loading} />
                                <CardBody>
                                    <div className="table-responsive table-card">
                                        <Table className="table-hover align-middle mb-0">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{width:10}}>&nbsp;</th>
                                                    <th><SortHeaderComponent title="Ticket #" column="request_number" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Status" column="status_name" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Customer Name" column="customer_name" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="CRM Invoice #" column="crm_invoice_number" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Tax Invoice #" column="tax_invoice_number" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Faseh Request #" column="faseh_request_number" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Certificate #" column="certificate_number" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Action Date" column="last_action_date" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Date Added" column="date_added" filter={filter} onSortChange={onSortChange} /></th>
                                                    <th><SortHeaderComponent title="Added By" column="added_by" filter={filter} onSortChange={onSortChange} /></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.dataList.map(function(item, index){
                                                    return(
                                                        <tr key={index}>
                                                            <td>
                                                                <div className="flex-shrink-0">
                                                                    <ul className="list-inline tasks-list-menu mb-0">
                                                                        <li className="list-inline-item">
                                                                            <Link to={`/request-edit/${item.id}`}>
                                                                                <i className="ri-pencil-fill fs-20 align-bottom text-primary"></i>
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div style={{whiteSpace:"nowrap"}}>
                                                                    <TicketLabel item={item} />
                                                                    <ComplianceLabel value={item.complianceState || ""} />
                                                                </div>
                                                                {item.ticketType === "CONTAINER" &&
                                                                <span className="badge bg-success">Container</span>
                                                                }
                                                            </td>
                                                            <td><span className="badge" style={{backgroundColor: item.statusColorCode}}>{item.statusName}</span></td>
                                                            <td>
                                                                <CustomerBadge item={item} />
                                                            </td>
                                                            <td>{item.crmInvoiceNumber}</td>
                                                            <td>{item.taxInvoiceNumber}</td>
                                                            <td>{item.fasehRequestNumber}</td>
                                                            <td>{item.certificateNumber}</td>
                                                            <td><MyDateRenderer value={item.lastActionDate} /></td>
                                                            <td><MyDateRenderer value={item.dateAdded} /></td>
                                                            <td>{item.addedBy}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <Row>
                                        <Col lg={12}>
                                            <PaginationComponent
                                                total={list.totalCount}
                                                currentPage={filter.pageIndex}
                                                onPageChange={page => onPageChange(page)}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default TicketSearchScreenSOFC;